import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Progress } from 'reactstrap';

const ContractModal = ({ open, onClose, onAccept, contractText, onFullyRead }) => {
    const contentRef = useRef(null);
    const [atBottom, setAtBottom] = useState(false);
    const [progress, setProgress] = useState(0);

    // Modal her açıldığında ilerlemeyi sıfırla
    useEffect(() => {
        if (open) {
            setAtBottom(false);
            setProgress(0);
            // küçük bir gecikme ile hesapla (render sonrasında)
            setTimeout(checkScroll, 0);
        }
    }, [open, contractText]);

    const checkScroll = () => {
        const el = contentRef.current;
        if (!el) return;
        const { scrollTop, scrollHeight, clientHeight } = el;

        // progress
        const p = Math.min(100, Math.round(((scrollTop + clientHeight) / scrollHeight) * 100));
        setProgress(p);

        // En alta yakınsa (3px tolerans)
        const atEnd = scrollTop + clientHeight >= scrollHeight - 3;
        if (atEnd && !atBottom) {
            setAtBottom(true);
            onFullyRead?.(); // parent'a "tam okundu" sinyali
        }
    };

    return (
        <Modal isOpen={open} toggle={onClose} size="lg" scrollable>
            <ModalHeader toggle={onClose}>
                <i className="bx bx-file-doc me-2"></i>
                Online Tahsilat Sözleşmesi
            </ModalHeader>

            <ModalBody>
                <div className="mb-2" aria-hidden>
                    <small className="text-muted">
                        Lütfen metnin sonuna kadar kaydırın. (%{progress})
                    </small>
                    <Progress value={progress} className="mt-1" />
                </div>
                <div
                    ref={contentRef}
                    onScroll={checkScroll}
                    style={{
                        fontSize: 14,
                        maxHeight: '60vh',
                        overflowY: 'auto',
                        whiteSpace: 'pre-wrap',
                        paddingRight: 8,
                        border: '1px solid #eee',
                        borderRadius: 6
                    }}
                >
                    {contractText}
                </div>
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={onClose}>
                    <i className="bx bx-x me-2" />
                    Kapat
                </Button>
                <Button
                    color="primary"
                    onClick={onAccept}
                    disabled={!atBottom} // SONA İNMEDEN KABUL ET TUŞU KAPALI
                >
                    <i className="bx bx-check me-2" />
                    Kabul Et ve Kapat
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ContractModal;